import { z } from 'zod';

import {
	BankDocumentTemplateV5,
	ClientDocumentCategoryV5,
} from '../../../../../../api/generated/cz.partners.bank.backofficegateway.documents';
import { createDateSchemaWithDefinedMinAndMaxBankValues } from '../../../../../../helpers/zod/createDateSchemaWithDefinedMinAndMaxBankValues';
import { validateDateRange } from '../../../../../../helpers/zod/validateDateRange';
import {
	WITHOUT_RESTRICTION,
	IS_VALID,
	IS_INVALID,
} from '../components/BinaryFilterRadioGroup';
import { ALL_DOCUMENT_CATEGORIES } from '../hooks/useGetDocumentCategorySelectOptions';

const documentsBinaryFilterStates = [
	IS_VALID,
	IS_INVALID,
	WITHOUT_RESTRICTION,
] as const;

const documentsBinaryFilterSchema = z
	.enum(documentsBinaryFilterStates)
	.optional();

const categorySchema = z
	.union([
		z.literal(ALL_DOCUMENT_CATEGORIES),
		z.enum(BankDocumentTemplateV5),
		z.enum(ClientDocumentCategoryV5),
	])
	.optional();

export type DocumentFilterMessages = {
	creationDateFromError: string;
	creationDateToError: string;
	creationDateToBeforeFromError: string;
	dateCantBeEarlierThanBankInceptionDateError: string;
};

export const getDocumentsFilterSchema = (
	errorMessages?: DocumentFilterMessages,
) => {
	const documentsFilterSchema = z
		.object({
			searchText: z.string().nullish(),
			category: categorySchema,
			archived: documentsBinaryFilterSchema,
			creationDateFrom: createDateSchemaWithDefinedMinAndMaxBankValues({
				minDateErrorMessage:
					errorMessages?.dateCantBeEarlierThanBankInceptionDateError,
				maxDateErrorMessage: errorMessages?.creationDateFromError,
			}),
			creationDateTo: createDateSchemaWithDefinedMinAndMaxBankValues({
				minDateErrorMessage:
					errorMessages?.dateCantBeEarlierThanBankInceptionDateError,
				maxDateErrorMessage: errorMessages?.creationDateToError,
			}),
		})
		.superRefine(({ creationDateFrom, creationDateTo }, ctx) => {
			validateDateRange(
				creationDateFrom,
				creationDateTo,
				errorMessages?.creationDateToBeforeFromError,
				ctx,
				'creationDateTo',
			);
		});
	return documentsFilterSchema;
};

export type DocumentsFilterType = z.infer<
	ReturnType<typeof getDocumentsFilterSchema>
>;
